import { gql } from "@apollo/client";

export const TRANSACTION_FRAGMENT = gql`
  fragment TransactionFragment on Transaction {
    id
    type
    status
    beneficiaryId
    beneficiaryName
    goalId
    goalName
    goalType
    description
    amountInCents
    reason
    date
    scheduledDate
    processingDate
    completedDate
    estimatedCompletionDateRange
    subscriptionPeriod
  }
`;
